import { useMemo } from 'react'
import ITHeaderText from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import InputTableLeftColumnForm from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/InputTableLeftColumnForm'
import { InputTableLeftTabsProps } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/types'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import TitleQuoteCost from '../../../../../../../specificComponents/TitleQuoteCosts'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { getCostsBuy, getAllCurrencies } from '../../../../../../../utils/reducers/getters'
import { CustomRenderString } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'

interface BuyReadOnlyHeaderCostsProps extends InputTableLeftTabsProps {}

const BuyReadOnlyHeaderCosts: React.FC<BuyReadOnlyHeaderCostsProps> = ({ headerData, handleChange }) => {
    const { t } = useTwinTranslation()
    const dictCosts = useMemo(() => getCostsBuy() || {}, [])
    const costs = headerData.OrderCosts
    const currencyHeaderId = headerData.CurrencyId
    const currencies = getAllCurrencies()
    const sections: FormRender<any> = []
    if (costs?.length>0) {
        for (let key in costs) {
            const costBuy = costs[key]
            const cost = dictCosts[costBuy.CostId]
            sections.push({
                title: <TitleQuoteCost cost={cost} />,
                cols: 1,
                elements: [
                    {
                        name: 'cost_' + cost.id + '_' + key,
                        component: 'Custom',
                        render: ({ value }) => <ITHeaderText label={t('cost', 'Coste')} value={costBuy?.initialPriceWithoutTax + ' ' + currencies[currencyHeaderId]?.symbolNative} />
                    },
                ]
            })
        }
    }else {
        sections.push({
            title: '',
            cols: 1,
            elements: [
                {
                    name: 'noCost',
                    component: 'Custom',
                    render: () => <CustomRenderString value={t('noCosts', 'Sin costes')} />
                },
            ]
        })
    }
    return (
        <InputTableLeftColumnForm form={sections} handleChange={handleChange} headerData={headerData} />
    )
}


export default BuyReadOnlyHeaderCosts